// extracted by mini-css-extract-plugin
export default {"Gauge":"ServerTile_Gauge__oIqSn"};